<script>
export default {
  functional: true,

  props: {
    src: {
      type: String,
      default: ''
    }
  },

  render(h, { data, props }) {
    return (
      props.src && (
        <img
          {...data}
          src={props.src}
          alt="Evidence"
          style={{ display: 'block', maxWidth: '100%', margin: '0 auto' }}
        />
      )
    )
  }
}
</script>
